module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-inner-1200.176b009f.svg";